import { MapPin, Phone, Navigation, Globe } from 'lucide-react';
import { Button } from '@/components/ui';

interface CompactContactSectionProps {
  address: string;
  phoneNumber: string | null;
  websiteUrl: string | null;
}

export function CompactContactSection({
  address,
  phoneNumber,
  websiteUrl,
}: CompactContactSectionProps) {
  const openDirections = () => {
    window.open(
      `https://maps.google.com/?q=${encodeURIComponent(address)}`,
      '_blank'
    );
  };

  const openWebsite = () => {
    if (websiteUrl) {
      window.open(websiteUrl, '_blank');
    }
  };

  // Show street + city (up to 2nd comma) on mobile, full on desktop
  const addressParts = address.split(',');
  const shortAddress = addressParts.slice(0, 2).join(',').trim();

  return (
    <div className="space-y-3">
      {/* Address and Phone stacked */}
      <div className="text-sm space-y-0.5">
        <div className="flex items-start gap-2">
          <MapPin className="h-4 w-4 mt-0.5 text-[var(--color-muted)] shrink-0" />
          {/* Short address on mobile, full on larger screens */}
          <p className="sm:hidden">{shortAddress}</p>
          <p className="hidden sm:block">{address}</p>
        </div>
        {phoneNumber && (
          <div className="flex items-center gap-2">
            <Phone className="h-4 w-4 text-[var(--color-muted)] shrink-0" />
            <a
              href={`tel:${phoneNumber}`}
              className="text-[var(--color-muted)] hover:text-[var(--color-text)]"
            >
              {phoneNumber}
            </a>
          </div>
        )}
      </div>

      {/* Side-by-side buttons */}
      <div className="flex gap-2">
        <Button
          variant="secondary"
          className="flex-1 flex items-center justify-center gap-1"
          onClick={openDirections}
        >
          <Navigation className="h-4 w-4" />
          Directions
        </Button>
        {websiteUrl && (
          <Button
            variant="secondary"
            className="flex-1 flex items-center justify-center gap-1"
            onClick={openWebsite}
          >
            <Globe className="h-4 w-4" />
            Website
          </Button>
        )}
      </div>
    </div>
  );
}
